import assign from 'lodash/assign';

import { LaunchChangePlanServiceModule } from 'components/changePlan/launchChangePlan.service';

import template from './appExtensionUpgradePlan.html';
import './appExtensionUpgradePlan.scss';

export const AppExtensionUpgradePlanModule = angular
    .module('app.components.appExtensionPreview.appExtensionUpgradePlan', [
        'ngMaterial',
        LaunchChangePlanServiceModule
    ])
    .component('appExtensionUpgradePlan', {
        template,
        bindings: {
            app: '<',
            appType: '<'
        },
        controller: class AppExtentionUpgradePlan {
            constructor($mdDialog, launchChangePlanService) {
                'ngInject';

                assign(this, {
                    $mdDialog,
                    launchChangePlanService
                });
            }

            openUpgradePlanDialog() {
                return this.$mdDialog.hide()
                    .then(() => this.launchChangePlanService.openModal());
            }

            closeConfirmUpgrade() {
                return this.$mdDialog.cancel('cancel');
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/appExtensionPreview/appExtensionUpgradePlan.component.js